<ng-container *ngIf="isLoaded$$ | async; else loadingState">
  <ng-container *ngIf="hasProducts$$ | async; else noProductsState">
    <ng-container *ngIf="columns$ | async as columns; else loadingState">
      <glxy-table-container
        [columns]="columns"
        [dataSource]="tableDataSource"
        [pageSizeOptions]="pageSizeOptions"
        [fullWidth]="true"
      >
        <glxy-table-content-header
          [showSearch]="true"
          [showFilters]="true"
          [showFiltersButton]="false"
          [showSort]="false"
          [showActions]="false"
        >
          <button
            mat-stroked-button
            filter-button
            class="glxy-filter-button"
            [ngClass]="{ 'filters-active': !isSidebarClosed }"
            (click)="toggleFilters()"
          >
            <mat-icon>filter_list</mat-icon>
            Filters
          </button>
        </glxy-table-content-header>

        <va-filter2-model name="account-metrics" [filterGroup]="filterGroup" [defaultSidebarState]="isSidebarClosed">
          <va-filter-content>
            <table mat-table matSort (matSortChange)="handleSortChange($event)">
              <tr mat-header-row *matHeaderRowDef="[]"></tr>

              <ng-container matColumnDef="account">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Account</th>
                <td mat-cell *matCellDef="let metrics">
                  <div>
                    {{ metrics.accountData?.companyName }}
                  </div>
                  <div class="subtext">
                    {{ metrics.accountData | glxyAddress }}
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="reseller">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Reseller</th>
                <td mat-cell *matCellDef="let metrics">
                  {{ metrics.resellerName }}
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let metrics">
                  <glxy-badge>
                    <ng-container *ngIf="metrics.accountStatus === activeAccountStatus; else inactiveStatus">
                      Active
                    </ng-container>
                    <ng-template #inactiveStatus>Inactive</ng-template>
                  </glxy-badge>
                </td>
              </ng-container>

              <ng-container matColumnDef="active-product-count">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Active products</th>
                <td mat-cell *matCellDef="let metrics">
                  <ng-container *ngIf="productIdToName$ | async as productIdToName; else plainData">
                    <a [glxyPopover]="popover" (mouseover)="popover.isOpen = true">
                      {{ metrics.totalActiveActivations }}
                    </a>

                    <glxy-popover
                      #popover
                      [positions]="[PopoverPositions.Bottom]"
                      [hasArrow]="true"
                      [padding]="'small'"
                      [hasBackdrop]="true"
                      (backdropClick)="popover.isOpen = false"
                    >
                      <app-activation-list
                        [businessId]="metrics.businessId"
                        [activations]="metrics.activations"
                        [productIdToName]="productIdToName"
                      ></app-activation-list>
                    </glxy-popover>
                  </ng-container>
                  <ng-template #plainData>{{ metrics.totalActiveActivations }}</ng-template>
                </td>
              </ng-container>

              <ng-container matColumnDef="created">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Since</th>
                <td mat-cell *matCellDef="let metrics">
                  {{ metrics.created | date : 'MMM dd, YYYY' }}
                </td>
              </ng-container>

              <ng-container *matNoDataRow="let metrics">
                <td [colSpan]="columns.length">
                  <ng-container *ngIf="(tableDataSource.loading$ | async) === false; then emptyStates"></ng-container>
                </td>
              </ng-container>

              <tr mat-row *matRowDef="let row; columns: []" class="account-table-row"></tr>
            </table>
          </va-filter-content>
        </va-filter2-model>
      </glxy-table-container>

      <ng-template #emptyStates>
        <ng-container
          *ngIf="
            resellerFilterControl.value.length !== 0 || productFilterControl.value.length !== 0;
            then filterState;
            else newState
          "
        ></ng-container>
        <ng-template #newState>
          <div class="empty-state">
            <mat-icon>person</mat-icon>
            <h2 class="empty-state-title">Watch your customer base grow</h2>
            <p class="empty-state-description">
              Accounts that have purchased your product from you or a reseller will show up here
            </p>
          </div>
        </ng-template>
        <ng-template #filterState>
          <div class="empty-state">
            <p class="empty-state-description">No results found for your filters</p>
          </div>
        </ng-template>
      </ng-template>
    </ng-container>
  </ng-container>
</ng-container>
<ng-template #loadingState>
  <div class="loading-state">
    <glxy-loading-spinner class="loading-spinner" size="large" fullHeight fullWidth></glxy-loading-spinner>
  </div>
</ng-template>

<ng-template #noProductsState>
  <glxy-empty-state class="empty-state">
    <glxy-empty-state-hero>
      <mat-icon>person</mat-icon>
    </glxy-empty-state-hero>
    <glxy-empty-state-title>Watch your customer base grow</glxy-empty-state-title>
    <p>Accounts that have purchased your product from you or a reseller will show up here</p>
    <glxy-empty-state-actions>
      <a mat-flat-button color="primary" [routerLink]="['/products']" [queryParams]="{ addProductsButton: true }">
        Create product
      </a>
      <a
        mat-stroked-button
        href="https://support.vendasta.com/hc/en-us/articles/4406959976471-Create-a-product"
        target="_blank"
      >
        Learn more
      </a>
    </glxy-empty-state-actions>
  </glxy-empty-state>
</ng-template>
